import { createContext } from 'react';

export const ViewModeContext = createContext(null);
ViewModeContext.displayName = 'ViewModeContext';
